import { useMemo } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip, ChipVariants } from '@frontend/design-system';
import { INSURANCE_STATUS_MAPPING } from '../../utils/constants';

type InsuranceStatusProps = {
  status: string;
};

type InsuranceStatusConfig = {
  variant: ChipVariants;
  iconName: IconName;
  text?: string;
};

export const InsuranceStatus = ({ status }: InsuranceStatusProps) => {
  const { t } = useTranslation('insuranceDetails');
  const { variant, iconName, text } = useMemo<InsuranceStatusConfig>(() => {
    const config = INSURANCE_STATUS_MAPPING.get(status.toLowerCase());

    if (config) {
      return {
        variant: config.variant,
        iconName: config.iconName,
        text: config.text,
      };
    }

    return {
      variant: 'warn',
      iconName: 'insurance-incomplete-small',
      text: t('Unverified'),
    };
  }, [status]);

  if (!status) {
    return (
      <Chip variant='default' css={chipStyles} leftElement={<Icon name='insurance-incomplete-small' />}>
        {status}
      </Chip>
    );
  }

  return (
    <Chip variant={variant} css={chipStyles} leftElement={<Icon name={iconName} css={{ color: 'currentcolor' }} />}>
      {text || status}
    </Chip>
  );
};

const chipStyles = css({
  width: 'fit-content',
  maxWidth: theme.spacing(16),
});
